import React, { useEffect, useState, useRef } from "react";
import { API } from "../../helper/Api";
import Select from "react-select"; // Import React Select
import { useNavigate, Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Multiselect from "multiselect-react-dropdown";
import { useRole } from "../contextApi/RoleContext";
import makeAnimated from 'react-select/animated';

const AddUsers = () => {
  const { setRole, role, setPermission, permission, setUserDetails,userDetails} =
    useRole();
    const animatedComponents = makeAnimated();
  // State to track selected permissions and role/category
  const navigate = useNavigate();
  const topRef = useRef(null);
  const [shakeName, setShakeName] = useState(false); // State for username shake
  const [isAddRolePopupOpen, setAddRolePopupOpen] = useState(false);
  const [newUser, setNewUser] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [err, setErr] = useState("");
  const [role1, setRole1] = useState("");
  const [getrole, setGetRoles] = useState([]);
  const [userType,setUserType] =useState("");
  const [getUserType, setGetUserType] = useState([]);
  const [matchedRole, setMatchedRole] = useState(null);
  const [permissions, setPermissions] = useState({
    view: false,
    edit: false,
    add: false,
  });
  const [isCategoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertMessage, setAlertMessage] = useState(""); // State for message
  const [users, setUsers] = useState([]); // State for selected users
  const [category1, setCategory1] = useState([]); // State for selected users
  const [userOptions, setUserOptions] = useState([]); // Options for the Users dropdown
  const [categoryOptions, setCategoryOptions] = useState([]); // Options for the category dropdown
  // State to track parent checkboxes and expand/collapse
  const [state, setState] = useState([]);
  const [errors, setErrors] = useState("");
  const [status1, setStatus1] = useState("1");
  const [checkboxValues, setCheckboxValues] = useState({
    sendMail: false,
    pwdReset: false,
  });
  let track = false;
  const [validation, setvalidation] = useState({
    userName: false,
    email: false,
    pwd: false,
    status: false,
    userRole: false,
    userType: false,
    storeCode: false,
  });
  const [validUser, setValidUser] = useState(null);
  const [validEmail, setValidEmail] = useState(null);
  const [storeCode, setStoreCode] = useState([]);
  const [selectedStoreCode, setSelectedStoreCode] = useState([]);
  const API_URL = process.env.REACT_APP_BASE_URL;
  const multiselectRef = useRef();
  // const userTypes1=["CORP","REGIONAL","STORES MGR","STORES OWNER"];
  // Define fetchData outside useEffect to call it explicitly
  const fetchData = async () => {
    try {
      let setId=role;
      if(userDetails.usertype?.trim() ==="CORP"){
setId=0;
      }
      const res = await API.accessSetting("getrole",setId);
      if (res.success) {
        setGetRoles(res.content);
  //       if(userDetails.usertype?.trim() ==="CORP"){
  //         setGetRoles(res.content);
  //       }else{
  // const filterUserRole = res.content.filter(it=> it.id.trim() === userDetails.role_id.trim());
  // setGetRoles(filterUserRole);
  //       }
        
        console.log("roles are here", res);
        // handle response if needed
      } else {
        console.log("Error in fetching roles");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  // get user type ///
  const fetchUserType = async () => {
    try {
      let setType=userDetails.usertype;
      if(userDetails.usertype?.trim() ==="CORP"){
        setType=userDetails.usertype;
      }
      const res = await API.accessSetting("getUserType",setType);
      if (res.success) {
        //setGetRoles(res.content);
        setGetUserType(res.content);
  //       if(userDetails.usertype?.trim() ==="CORP"){
  //         setGetUserType(res.content);
  //       }else{
  // const filterUserType = res.content.filter(it=> it.typename.trim() === userDetails.usertype);
  // setGetUserType(filterUserType);
  //       }
       // console.log("user types  are here", res);
        // handle response if needed
      } else {
        console.log("Error in fetching user types");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  /////fetch user list
  const fetchDataUsers = async () => {
    try {
      const res = await API.accessSetting("getuser",0);
      if (res.success) {
        // Assuming API returns a list of users, prepare options for the dropdown
        setUserOptions(res.content);
        console.log("user are here", res);
        // handle response if needed
      } else {
        console.log("Error in fetching users");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  ///end//////
   ///get the store code /////
   const fetchStoreCode = async () => {
    try {
      const res = await fetch(`${API_URL}location.php`);
      // Check if the response is successful (status 200)
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await res.json();
      console.log(result)
      const extractCode = result.ApiDocument.Response.Locations.map(
        (item) => {
          return { code: item.Code,value:item.Code,label:item.Code };
        }
      ).filter((item) => item.code);
      if(userDetails.usertype !=="CORP"){
        const filterCodeBasedOnUser= extractCode.filter(item => userDetails.storecode.some(its=> its.storecode === item.code));
        setStoreCode(filterCodeBasedOnUser);
        console.log("filtered code1",filterCodeBasedOnUser)
      }else{
        console.log("filtered code2",extractCode)
        setStoreCode(extractCode);
      }
      
      
      // console.log("store code", extractCode);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //////////////////////////////
  // Handle checkbox change
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxValues((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };
  const handlePwdChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    setvalidation((prev) => ({ ...prev, pwd: false }));
    // Define validation criteria
    const validations = {
      length: value.length >= 8,
      specialChar: /[@$!%*?&#]/.test(value),
      uppercase: /[A-Z]/.test(value),
      number: /\d/.test(value),
    };

    // Check if all validations pass
    const allValid = Object.values(validations).every(Boolean);

    if (allValid) {
      setErrors({});
    } else {
      // Create feedback messages
      const feedback = {
        length: validations.length
          ? "Password length is sufficient"
          : "Password must be at least 8 characters long",
        specialChar: validations.specialChar
          ? "Special character included"
          : "Include at least one special character",
        uppercase: validations.uppercase
          ? "Uppercase letter included"
          : "Include at least one uppercase letter",
        number: validations.number
          ? "Number included"
          : "Include at least one number",
      };
      setErrors(feedback);
    }
  };

  // Call fetchData initially when the component mounts
  useEffect(() => {
    console.log("test",userDetails.storecode)
    fetchData();
    fetchDataUsers();
    fetchUserType();
    fetchStoreCode();
    // fetchDataCategory();
  }, []);

  const handleChangeUser = (e) => {
    let getUser = e.target.value;
    setNewUser(e.target.value);
    setvalidation((prev) => ({ ...prev, userName: false }));
    if (getUser.trim()) {
      var filterUser = userOptions.filter(
        (item) => item.username.toLowerCase() === getUser.toLowerCase()
      );
      if (filterUser.length > 0) {
        setValidUser("(The below user already exist)");
      } else {
        setValidUser(null);
      }
    }
  };

  const handleEmail = (e) => {
    let userEmail = e.target.value;
    setNewEmail(e.target.value);
    setvalidation((prev) => ({ ...prev, email: false }));
    if (userEmail.trim()) {
      var filterEmail = userOptions.filter(
        (item) => item.email.toLowerCase() === userEmail.toLowerCase()
      );
      if (filterEmail.length > 0) {
        setValidEmail("(The below email id already exist)");
      } else {
        setValidEmail(null);
      }
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    console.log("select",selectedStoreCode.length);
    try {
      console.log("get", Object.entries(errors).length != 0);
      if (newUser.trim() === "") {
        track = true;
        setvalidation((prev) => ({
          ...prev,
          userName: true,
        }));
      }
      if (validUser !== null) {
        track = true;
      }
      if (validEmail !== null) {
        track = true;
      }
      if (newEmail.trim() === "") {
        setvalidation((prev) => ({
          ...prev,
          email: true,
        }));
        track = true;
      }
      if (newPassword.trim() === "" || Object.entries(errors).length != 0) {
        setvalidation((prev) => ({
          ...prev,
          pwd: true,
        }));
        track = true;
      }
      if (selectedStoreCode.length <= 0) {
        setvalidation((prev) => ({
          ...prev,
          storeCode: true,
        }));
        track = true;
      }
      if (role1 === "") {
        setvalidation((prev) => ({
          ...prev,
          userRole: true,
        }));
        track = true;
      }
      if (userType === "") {
        setvalidation((prev) => ({
          ...prev,
          userType: true,
        }));
        track = true;
      }
      if (status1.trim() === "") {
        setvalidation((prev) => ({
          ...prev,
          status: true,
        }));
        track = true;
      }
      if (!track) {
        const apiData = {
          username: newUser,
          email: newEmail,
          userpwd: newPassword,
          role: Number(role1),
          status: Number(status1),
          sendmail: checkboxValues.sendMail,
          pwdreset: checkboxValues.pwdReset,
          userTypeId:Number(userType),
          storeCode:selectedStoreCode
        };
        //console.log("success")
        const res = await API.accessSetting("submitAddUser", apiData);
        if (res.success) {
          apiData.id = res.id;
          toast.success("User Added successfully!", {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            className: "login-toast",
          });
          // setAlertMessage("User Added successfully!");
          // setAlertVisible(true);
          // setTimeout(() => setAlertVisible(false), 10000); // Hide the alert after 3 seconds
          topRef.current.scrollIntoView({ behavior: "smooth" });
          if (checkboxValues.sendMail) {
            const sendemail = await API.accessSetting(
              "sendMailToUser",
              apiData
            );
          }
          fetchDataUsers();
          setNewUser("");
          setNewEmail("");
          setNewPassword("");
          setRole1("");
          setStatus1("1");
          setCheckboxValues({
            sendMail: false,
            pwdReset: false,
          });
          setUserType("");
          setSelectedStoreCode([]);
          multiselectRef.current.resetSelectedValues();
        } else {
          toast.error("Failed to add user. Please try again.", {
            position: "top-center",
            autoClose: false,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            className: "login-toast",
          });
          // setAlertMessage("Failed to add user. Please try again.");
          // setAlertVisible(true);
          // setTimeout(() => setAlertVisible(false), 3000); // Hide the alert after 3 seconds
        }
      }
      // else {
      //   // alert(
      //   //   "Please ensure all required fields are filled out before proceeding"
      //   // );
      // }
      // if (topRef.current) {
      //   topRef.current.scrollIntoView({ behavior: "smooth" });
      // }
    } catch (error) {
      console.error("Error submitting form:", error); // Handle errors
    }
  };
  const openAddRolePopup = () => {
    setAddRolePopupOpen(true);
  };

  const closeAddRolePopup = () => {
    setAddRolePopupOpen(false);
    setNewUser("");
    setErr("");
  };
  ///get the selected store code//
  const handleStoreCode = (selectedValues) => {
    
    setvalidation((prev)=>({...prev,storeCode:false}));
    setSelectedStoreCode(selectedValues);
    

  };
  ///end////

  

  const containerStyles = {
    padding: "30px",
    width: "60%",
    borderRadius: "8px",
    // backgroundColor: '#f8f9fa',
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)", // Light shadow for a floating effect
  };

  const labelStyles = {
    fontWeight: "600",
    marginBottom: "8px",
    fontSize: "14px",
  };

  const selectStyles = {
    width: "100%",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
     marginBottom: '15px',
    outline: "none",
    cursor: "pointer",
    height: "47px",
    color: "black",
  };

  const dropdownStyles = {
    position: "absolute",
    border: "1px solid #ced4da",
    backgroundColor: "#fff",
    width: "90%",
    zIndex: "1000",
    maxHeight: "200px",
    overflowY: "auto",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    borderRadius: "4px",
    padding: "10px",
  };

  const checkboxStyles = {
    margin: "5px 0",
  };

  const permissionLabelStyles = {
    marginLeft: "5px",
  };
  const invalidFeedbackStyle = {
    color: "red",
    fontSize: "12px",
    marginTop: "-8px",
    marginBottom: "10px",
  };

  return (
    <div className="container-fluid page-body-wrapper" ref={topRef}>
      {/* Add the Shake Keyframe Animation */}
      <style>
        {`
          @keyframes shake {
            0% { transform: translateX(0); }
            25% { transform: translateX(-5px); }
            50% { transform: translateX(5px); }
            75% { transform: translateX(-5px); }
            100% { transform: translateX(0); }
          }

          .shake {
            animation: shake 0.5s ease-in-out;
          }
        `}
      </style>
      <div className="main-panel">
        <div className="content-wrapper">
          <ToastContainer
            position="top-center"
            autoClose={500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <div className="container mainbody" >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2 className="form-header">Create New User</h2>
              <Link to="/users" className="backButton">
                <i class="mdi mdi-arrow-left"></i>Back
              </Link>
            </div>

            {alertVisible && (
              <div
                style={{
                  marginBottom: "1rem",
                  padding: "1rem",
                  backgroundColor: alertMessage.includes("error")
                    ? "#dc3545"
                    : "#28a745",
                  color: "white",
                  borderRadius: "5px",
                  textAlign: "center",
                }}
              >
                {alertMessage}
              </div>
            )}
            <form onSubmit={handleFormSubmit} style={{ marginTop: "15px" }}>
              {/* Role label in a separate row */}
              <div className="form-group">
                <label htmlFor="role" style={labelStyles}>
                  User Name<span className="requireds">*</span>
                  {validation.userName && (
                    <span className="fieldValidation">
                      (Username is required)
                    </span>
                  )}{" "}
                  {validUser && (
                    <span className="fieldValidation">{validUser}</span>
                  )}
                </label>
                <input
                  id="username1"
                  type="text"
                  placeholder="Enter your username"
                  value={newUser}
                  onChange={handleChangeUser}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />

                <label htmlFor="role" style={labelStyles}>
                  Email<span className="requireds">*</span>
                  {validation.email && (
                    <span className="fieldValidation">(Email is required)</span>
                  )}
                  {validEmail && (
                    <span className="fieldValidation">{validEmail}</span>
                  )}
                </label>
                <input
                  id="useremail1"
                  type="email"
                  placeholder="Email (e.g., name@example.com)"
                  value={newEmail}
                  onChange={handleEmail}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />
                <label htmlFor="role" style={labelStyles}>
                  Password<span className="requireds">*</span>
                  {validation.pwd && (
                    <span className="fieldValidation">
                      (Password is required)
                    </span>
                  )}
                </label>
                <input
                  id="userpassword1"
                  type="password"
                  placeholder="Enter your password"
                  value={newPassword}
                  onChange={handlePwdChange}
                  style={{
                    width: "100%",
                    padding: "8px",
                    marginBottom: "15px",
                    borderRadius: "4px",
                    border: "1px solid #ced4da",
                    fontSize: "14px",
                    height:"47px"
                  }}
                />
                {errors && (
                  <div style={invalidFeedbackStyle}>
                    {Object.entries(errors).map(([key, message]) => (
                      <p
                        key={key}
                        style={{
                          color:
                            message.includes("included") ||
                            message.includes("sufficient")
                              ? "#0dc10d"
                              : "red",
                          margin: "5px 0",
                        }}
                      >
                        {message}
                      </p>
                    ))}
                  </div>
                )}
                <label htmlFor="status1" style={labelStyles}>
                  Status<span className="requireds">*</span>
                  {validation.status && (
                    <span className="fieldValidation">
                      (Status is required)
                    </span>
                  )}
                </label>
                <select
                  id="status1"
                  className="form-control"
                  value={status1}
                  onChange={(e) => {
                    setStatus1(e.target.value);
                    setvalidation((prev) => ({ ...prev, status: false }));
                  }}
                  style={{ ...selectStyles, marginRight: "10px" }}
                >
                  <option value="">Select status</option>
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
                 
                <label
                  htmlFor="userType"
                  style={labelStyles}
                >
                 User Type<span className="requireds">*</span>
                  {validation.userType && (
                    <span className="fieldValidation">(User Type is required)</span>
                  )}
                </label>
                <select
                  id="userType"
                  className="form-control"
                  value={userType}
                  onChange={(e) => {
                    setUserType(e.target.value);
                    setvalidation((prev) => ({ ...prev, userType: false }));
                  }}
                  style={{ ...selectStyles, marginRight: "10px" }}
                >
                  <option value="">Select</option>
                  {getUserType
                    ?getUserType.map((item, index) => (
                        <option key={item.id} value={item.id}>
                          {item.typename.trim()}
                        </option>
                      ))
                    : ""}
                </select>
                <label
                  htmlFor="role"
                  style={labelStyles}
                >
                  User Role<span className="requireds">*</span>
                  {validation.userRole && (
                    <span className="fieldValidation">(Role is required)</span>
                  )}
                </label>
                <select
                  id="role"
                  className="form-control"
                  value={role1}
                  onChange={(e) => {
                    setRole1(e.target.value);
                    setvalidation((prev) => ({ ...prev, userRole: false }));
                  }}
                  style={{ ...selectStyles, marginRight: "10px" }}
                >
                  <option value="">Select</option>
                  {getrole
                    ? getrole.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.role_name}
                        </option>
                      ))
                    : ""}
                </select>
                <label
                  htmlFor="storecode"
                  style={labelStyles}
                >
                 Store Code<span className="requireds">*</span>
                  {validation.storeCode && (
                    <span className="fieldValidation">(Store Code is required)</span>
                  )}
                </label>
                {/* <Multiselect
                  id="storecode"
                  displayValue="code"
                  ref={multiselectRef}
                  onKeyPressFn={function noRefCheck() {}}
                  onRemove={function noRefCheck() {}}
                  onSearch={function noRefCheck() {}}
                  onSelect={handleStoreCode}
                  options={storeCode}
                  placeholder=""
                /> */}
                 <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      onChange={handleStoreCode}
      options={storeCode} 
      placeholder="Select Store Code" 
      className="newselect"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: '#1967d2',
          primary: 'rgb(3 207 217)',
        },
       
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight:'47px'
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color:'black',
          outline:'none'
        }),
        input: (baseStyles, state) => ({
          ...baseStyles,
          outline:'none'
        })
      }
    
    }
      
    />
                
                <div
                  className="mb-3 d-flex align-items-center"
                  style={{ gap: "30px" }}
                >
                  <div
                    className="form-check me-3"
                    style={{ marginLeft: "22px" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="sendMail"
                      name="sendMail"
                      checked={checkboxValues.sendMail}
                      onChange={handleCheckboxChange}
                      style={{
                        width: "20px",
                        marginLeft: "-30%",
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="checkbox1"
                      style={{ marginLeft: "0px", marginTop: "1px" }}
                    >
                      Send Email
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="pwdReset"
                      name="pwdReset"
                      checked={checkboxValues.pwdReset}
                      onChange={handleCheckboxChange}
                      style={{
                        width: "20px",
                        marginLeft: "-21%",
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="checkbox2"
                      style={{ marginLeft: "0px", marginTop: "1px" }}
                    >
                      Password Reset
                    </label>
                  </div>
                </div>
              </div>
              {/* Submit button */}
              <div style={{ display: "flex", gap: "5px" }}>
                <button
                  type="submit"
                  className="submit-btn"
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    backgroundColor: "rgb(108,117,125)",
                    color: "#fff",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                  onClick={() => navigate("/users")}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-btn"
                  style={{
                    padding: "10px 20px",
                    border: "none",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUsers;
